// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section__VideoSection-module--cGWbb {
    background: var(--color-surface-inverse);
    color: var(--color-neutral-100);
    padding: var(--space-3xl) var(--space-md);
    border-radius: var(--home-radius-3xl) var(--home-radius-3xl) 0 0;
}

.inner__VideoSection-module--l1EcV {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: var(--space-lg);
}

.heading__VideoSection-module--xDL1a {
    margin: 0;
    font-size: var(--home-text-heading-lg);
    font-weight: 800;
    letter-spacing: -0.03em;
    line-height: 0.98;
    color: var(--color-text-on-brand);
}

.highlight__VideoSection-module--UIIX2 {
    color: var(--home-color-orange);
}

.videoFrame__VideoSection-module--afgEl {
    border-radius: var(--home-radius-2xl);
    overflow: hidden;
}

.videoFrame__VideoSection-module--afgEl video {
    display: block;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: var(--color-neutral-800);
}

.actions__VideoSection-module--ct7pa {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-md);
}

.hint__VideoSection-module--lDKmP {
    margin: 0;
    font-size: 16px;
    color: var(--color-neutral-300);
}

.hint__VideoSection-module--lDKmP a {
    color: var(--color-text-on-brand);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/VideoSection.module.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,yCAAyC;IACzC,gEAAgE;AACpE;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,sCAAsC;IACtC,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":[".section {\n    background: var(--color-surface-inverse);\n    color: var(--color-neutral-100);\n    padding: var(--space-3xl) var(--space-md);\n    border-radius: var(--home-radius-3xl) var(--home-radius-3xl) 0 0;\n}\n\n.inner {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-lg);\n}\n\n.heading {\n    margin: 0;\n    font-size: var(--home-text-heading-lg);\n    font-weight: 800;\n    letter-spacing: -0.03em;\n    line-height: 0.98;\n    color: var(--color-text-on-brand);\n}\n\n.highlight {\n    color: var(--home-color-orange);\n}\n\n.videoFrame {\n    border-radius: var(--home-radius-2xl);\n    overflow: hidden;\n}\n\n.videoFrame video {\n    display: block;\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    background: var(--color-neutral-800);\n}\n\n.actions {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: var(--space-md);\n}\n\n.hint {\n    margin: 0;\n    font-size: 16px;\n    color: var(--color-neutral-300);\n}\n\n.hint a {\n    color: var(--color-text-on-brand);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `section__VideoSection-module--cGWbb`,
	"inner": `inner__VideoSection-module--l1EcV`,
	"heading": `heading__VideoSection-module--xDL1a`,
	"highlight": `highlight__VideoSection-module--UIIX2`,
	"videoFrame": `videoFrame__VideoSection-module--afgEl`,
	"actions": `actions__VideoSection-module--ct7pa`,
	"hint": `hint__VideoSection-module--lDKmP`
};
export default ___CSS_LOADER_EXPORT___;
